module.exports = __webpack_public_path__ + "static/media/jewelry-store.71fd3c0f.jpg";